import axios from 'axios'
import {docCookies} from '../utils/docCookies'
import {ApiHelper, axiosInstance } from '../utils/ApiHelper'
import AnalyticsHelper from '../utils/AnalyticsHelper'
import CloudEvent from '../utils/CloudEvent'
import {startSubmit, stopSubmit, reset} from 'redux-form';
import { SubmissionError } from 'redux-form';

//
// Accountant Groups
//
export const HIDE_CREATE_ACCOUNTANT_GROUP_MODAL = 'HIDE_CREATE_ACCOUNTANT_GROUP_MODAL'
export function hideCreateAccountantGroupModal() {
  return {
    type: HIDE_CREATE_ACCOUNTANT_GROUP_MODAL
  }
}

export const CREATE_ACCOUNTANT_GROUP_REQUEST = 'CREATE_ACCOUNTANT_GROUP_REQUEST'
export const CREATE_ACCOUNTANT_GROUP_SUCCESS = 'CREATE_ACCOUNTANT_GROUP_SUCCESS'
export const CREATE_ACCOUNTANT_GROUP_FAILURE = 'CREATE_ACCOUNTANT_GROUP_FAILURE'
export function createAccountantGroupRequest() {
  return {
    type: CREATE_ACCOUNTANT_GROUP_REQUEST
  }
}
function createAccountantGroupSuccess(json) {
  return {
    type: CREATE_ACCOUNTANT_GROUP_SUCCESS,
    json: json,
    receivedAt: Date.now()
  }
}
function createAccountantGroupFailure() {
  return {
    type: CREATE_ACCOUNTANT_GROUP_FAILURE,
    receivedAt: Date.now()
  }
}
export function createAccountantGroup(data) {
  return dispatch => {

    dispatch(startSubmit('AccountantProfileForm'));
    dispatch(createAccountantGroupRequest());

    // using updateAccountantGroup is correct, as we employ a create or update pattern in the server
    return ApiHelper.updateAccountantGroup(data).then(response => {

      if (response.status != 201) {
        dispatch(createAccountantGroupFailure())
        dispatch(stopSubmit('AccountantProfileForm'));

      } else {
        dispatch(createAccountantGroupSuccess(response.data))
        dispatch(stopSubmit('AccountantProfileForm'));

      }

    }).catch( err => {
      console.log(err);
      dispatch(createAccountantGroupFailure())
      dispatch(stopSubmit('AccountantProfileForm'));

    })
  }
}

export const RESET_ACCOUNTANT_GROUP_FORM = 'RESET_ACCOUNTANT_GROUP_FORM'
export const UPDATE_ACCOUNTANT_GROUP_REQUEST = 'UPDATE_ACCOUNTANT_GROUP_REQUEST'
export const UPDATE_ACCOUNTANT_GROUP_SUCCESS = 'UPDATE_ACCOUNTANT_GROUP_SUCCESS'
export const UPDATE_ACCOUNTANT_GROUP_FAILURE = 'UPDATE_ACCOUNTANT_GROUP_FAILURE'
export function resetAccountantGroupForm() {
  return {
    type: RESET_ACCOUNTANT_GROUP_FORM
  }
}
export function updateAccountantGroupRequest() {
  return {
    type: UPDATE_ACCOUNTANT_GROUP_REQUEST
  }
}
function updateAccountantGroupSuccess(json) {
  return {
    type: UPDATE_ACCOUNTANT_GROUP_SUCCESS,
    json: json,
    receivedAt: Date.now()
  }
}
function updateAccountantGroupFailure() {
  return {
    type: UPDATE_ACCOUNTANT_GROUP_FAILURE,
    receivedAt: Date.now()
  }
}
export function updateAccountantGroup(data) {
  return dispatch => {

    dispatch(startSubmit('AccountantProfileForm'));
    dispatch(updateAccountantGroupRequest());

    return ApiHelper.updateAccountantGroup(data).then(response => {

      if (response.status != 201) {
        // throw new SubmissionError({email: "this is an error"})

        dispatch(updateAccountantGroupFailure())
        dispatch(stopSubmit('AccountantProfileForm'));

      } else {

        dispatch(updateAccountantGroupSuccess(response.data))
        dispatch(stopSubmit('AccountantProfileForm'));

      }

    }).catch( err => {
      console.log(err);
      dispatch(updateAccountantGroupFailure())
      dispatch(stopSubmit('AccountantProfileForm'));

    })
  }
}

export function getClient(tokenId, data = {}) {
  return dispatch => {
    dispatch({type:'GET_CLIENT_REQUEST', tokenId})
    return ApiHelper.getClient(tokenId, data).then(response => {
      if (response.status != 200) {
        dispatch({type:'GET_CLIENT_FAIL', tokenId})
        return response
      } else {
        dispatch({type:'GET_CLIENT_SUCCESS', tokenId, client: response.data})
        return response
      }
    }).catch( err => {
      console.log(err);
      dispatch({type:'GET_CLIENT_FAIL', tokenId, err})
    })
  }
}


export const GET_ACCOUNTANT_GROUP_REQUEST = 'GET_ACCOUNTANT_GROUP_REQUEST'
export const GET_ACCOUNTANT_GROUP_SUCCESS = 'GET_ACCOUNTANT_GROUP_SUCCESS'
export const GET_ACCOUNTANT_GROUP_FAILURE = 'GET_ACCOUNTANT_GROUP_FAILURE'
export function getAccountantGroupRequest() {
  return {
    type: GET_ACCOUNTANT_GROUP_REQUEST
  }
}
function getAccountantGroupSuccess(json) {
  return {
    type: GET_ACCOUNTANT_GROUP_SUCCESS,
    json: json,
    receivedAt: Date.now()
  }
}
function getAccountantGroupFailure() {
  return {
    type: GET_ACCOUNTANT_GROUP_FAILURE,
    receivedAt: Date.now()
  }
}
export function getAccountantGroup(data={}) {
  return dispatch => {

    dispatch(startSubmit('AccountantProfileForm'));
    dispatch(getAccountantGroupRequest());

    return ApiHelper.getAccountantGroup(data).then(response => {

      if (response.status != 200) {
        console.log(response.status);

        dispatch(getAccountantGroupFailure())

      } else {

        dispatch(getAccountantGroupSuccess(response.data))

      }
    }).catch( err => {
      console.log(err);
      dispatch(getAccountantGroupFailure())

    })
  }
}

export const RESET_CREATE_CLIENT_INVITES_FORM = 'RESET_CREATE_CLIENT_INVITES_FORM'
export const CREATE_CLIENT_INVITES_REQUEST = 'CREATE_CLIENT_INVITES_REQUEST'
export const CREATE_CLIENT_INVITES_SUCCESS = 'CREATE_CLIENT_INVITES_SUCCESS'
export const CREATE_CLIENT_INVITES_FAILURE = 'CREATE_CLIENT_INVITES_FAILURE'
export function resetCreateClientInvitesForm() {
  return {
    type: RESET_CREATE_CLIENT_INVITES_FORM
  }
}
export function createClientInvitesRequest() {
  return {
    type: CREATE_CLIENT_INVITES_REQUEST
  }
}
function createClientInvitesSuccess(json) {
  return {
    type: CREATE_CLIENT_INVITES_SUCCESS,
    json: json,
    receivedAt: Date.now()
  }
}
function createClientInvitesFailure() {
  return {
    type: CREATE_CLIENT_INVITES_FAILURE,
    receivedAt: Date.now()
  }
}
export function createClientInvites(data) {
  return dispatch => {

    dispatch(startSubmit('AddMemberForm'));
    dispatch(createClientInvitesRequest());

    return ApiHelper.createClientInvites(data).then(response => {

      if (response.status != 201) {

        dispatch(createClientInvitesFailure())
        dispatch(stopSubmit('AddMemberForm'));

      } else {

        dispatch(createClientInvitesSuccess(response.data))
        dispatch(stopSubmit('AddMemberForm'));

      }

    }).catch( err => {
      console.log(err);
      dispatch(createClientInvitesFailure())
      dispatch(stopSubmit('AddMemberForm'));

    })
  }
}



export const SEND_DATA_EXPORT_REQUEST = 'SEND_DATA_EXPORT_REQUEST'
export const SEND_DATA_EXPORT_SUCCESS = 'SEND_DATA_EXPORT_SUCCESS'
export const SEND_DATA_EXPORT_FAILURE = 'SEND_DATA_EXPORT_FAILURE'
function sendDataExportRequest() {
  return {
    type: SEND_DATA_EXPORT_REQUEST
  }
}
function sendDataExportSuccess() {
  return {
    type: SEND_DATA_EXPORT_SUCCESS,
    receivedAt: Date.now()
  }
}
function sendDataExportFailure() {
  return {
    type: SEND_DATA_EXPORT_FAILURE
  }
}
export function sendDataExport(token_id, data) {
  return dispatch => {

    dispatch(sendDataExportRequest())

    return ApiHelper.sendDataExport(token_id, data).then(response => {
      AnalyticsHelper.trackEvent(CloudEvent.DataExportFromAccountant)
      dispatch(sendDataExportSuccess())
    }).catch(response=>{
      dispatch(sendDataExportFailure())
    });
  }
}



// WEBPACK FOOTER //
// ./src/accountants/actions.js